import { render, staticRenderFns } from "./ProjectActionsDelete.vue?vue&type=template&id=5c1033e4&lang=pug&"
import script from "./ProjectActionsDelete.vue?vue&type=script&lang=js&"
export * from "./ProjectActionsDelete.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActionsDelete.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports